import React from 'react';
import CountUp from 'react-countup';
import { TimeUnits } from '../../Molecules/KpiWidget/KPIWidget.types';
import { KPIValue, KPIUnit } from './../../Molecules/KpiWidget/KPIWidget.styles';

const AnimatedTimeDisplay = ({ timeObject }: { timeObject: Record<TimeUnits, number> }) => {
  const formattedTimeParts: React.ReactNode[] = [];

  let unitCount = 0;

  for (const unit of Object.values(TimeUnits)) {
    if (timeObject[unit] > 0 && unitCount < 2) {
      formattedTimeParts.push(
        <React.Fragment key={unit}>
          <KPIValue variant='h3' key={`${unit}-value`}>
            <CountUp end={timeObject[unit]} preserveValue duration={0.5} key={`${unit}-countup`} />
          </KPIValue>
          <KPIUnit variant='h4' key={`${unit}-unit`}>
            {unit === TimeUnits.MIN ? 'm' : unit}
          </KPIUnit>
        </React.Fragment>
      );
      unitCount++;
    }
  }

  if (formattedTimeParts.length === 0) {
    return (
      <React.Fragment>
        <KPIValue variant='h3'>
          <CountUp end={0} preserveValue duration={0.5} key='default-countup' />
        </KPIValue>
        <KPIUnit variant='h4' key='default-unit'>
          s
        </KPIUnit>
      </React.Fragment>
    );
  }

  return <React.Fragment>{formattedTimeParts}</React.Fragment>;
};

export default AnimatedTimeDisplay;
